import { useState } from "react";
import { toast } from "sonner";
import { Lock, Plus, Trash2, NotebookPen } from "lucide-react";
import { api, errMsg, fmtDate, todayISO } from "@/lib/api";
import { EmptyState } from "@/components/Field";

export function NotesTab({ rec, reload }) {
  const [text, setText] = useState("");
  const [date, setDate] = useState(todayISO());

  const add = async (e) => {
    e.preventDefault();
    if (!text.trim()) return;
    try {
      await api.post(`/patients/${rec.patient.id}/notes`, { date, text });
      setText("");
      toast.success("Appunto salvato");
      reload();
    } catch (err) {
      toast.error(errMsg(err));
    }
  };
  const remove = async (id) => {
    if (!window.confirm("Eliminare l'appunto?")) return;
    await api.delete(`/notes/${id}`);
    reload();
  };

  return (
    <div className="space-y-6">
      <div className="flex items-center gap-2 rounded-2xl border border-orange-200 bg-orange-50 px-4 py-3 text-sm text-orange-800" data-testid="notes-private-banner">
        <Lock className="h-4 w-4" /> Gli appunti sono visibili solo alla dottoressa e non compaiono mai nell'area del paziente.
      </div>
      <form onSubmit={add} className="card space-y-3" data-testid="note-form">
        <div className="flex flex-wrap items-center justify-between gap-3">
          <h3 className="text-lg font-bold">Nuovo appunto</h3>
          <input type="date" className="field w-auto" value={date} onChange={(e) => setDate(e.target.value)} data-testid="note-date-input" />
        </div>
        <textarea className="field min-h-[120px]" value={text} onChange={(e) => setText(e.target.value)} placeholder="Anamnesi, osservazioni, abitudini alimentari, obiettivi…" data-testid="note-text-input" />
        <div className="flex justify-end"><button className="btn-dark" data-testid="note-save-button"><Plus className="h-4 w-4" /> Salva appunto</button></div>
      </form>
      {rec.notes.length ? (
        <div className="space-y-3">
          {rec.notes.map((n) => (
            <div key={n.id} className="relative rounded-2xl border border-[#e2e8f0] bg-white p-5 pl-6" data-testid={`note-item-${n.id}`}>
              <span className="absolute left-0 top-5 h-8 w-1 rounded-r-full bg-orange-300" />
              <div className="mb-2 flex items-center justify-between">
                <span className="label-xs">{fmtDate(n.date, { weekday: "long", day: "numeric", month: "long", year: "numeric" })}</span>
                <button className="btn-ghost text-slate-400 hover:text-rose-600" onClick={() => remove(n.id)} data-testid={`note-delete-${n.id}`}><Trash2 className="h-4 w-4" /></button>
              </div>
              <p className="whitespace-pre-line text-sm leading-relaxed">{n.text}</p>
            </div>
          ))}
        </div>
      ) : <EmptyState icon={NotebookPen} title="Nessun appunto" testid="notes-empty" />}
    </div>
  );
}
